import {
  START_LOADING,
  STOP_LOADING,
  START_COMPONENT_LOADING,
  STOP_COMPONENT_LOADING,
} from "../../constants/actionTypes";

const initialState = {
  isLoading: true,
  componentsLoading: {},
};

export const loadingReducer = (state = initialState, action) => {
  const { type, payload } = action;
  let components = state.componentsLoading;
  switch (type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case STOP_LOADING:
      return { ...state, isLoading: false };
    case START_COMPONENT_LOADING:
      return {
        ...state,
        componentsLoading: { ...components, [payload]: true },
      };
    case STOP_COMPONENT_LOADING:
      return {
        ...state,
        componentsLoading: { ...components, [payload]: false },
      };
    default:
      return state;
  }
};
